import { render, staticRenderFns } from "./pShop.vue?vue&type=template&id=59e32c39&scoped=true"
import script from "./pShop.vue?vue&type=script&lang=js"
export * from "./pShop.vue?vue&type=script&lang=js"
import style0 from "./pShop.vue?vue&type=style&index=0&id=59e32c39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e32c39",
  null
  
)

export default component.exports